const rawprofs = [
  "Administrador",
  "Advogado",
  "Aeronauta",
  "Arquivista / T\\u00e9cnico de Arquivo",
  "Artista/T\\u00e9cnico em espet\\u00e1culos de divers\\u00f5es",
  "Assistente Social",
  "Atleta Profissional de Futebol",
  "Atu\\u00e1rio",
  "Bibliotec\\u00e1rio",
  "Biom\\u00e9dico",
  "Bi\\u00f3logo",
  "Bombeiro Civil",
  "Comerci\\u00e1rio",
  "Contabilista",
  "Corretor de Im\\u00f3veis",
  "Corretor de Seguros",
  "Despachante Aduaneiro",
  "Engenheiro/ Arquiteto/ Agr\\u00f4nomo",
  "Economista Dom\\u00e9stico",
  "Economista",
  "Educa\\u00e7\\u00e3o F\\u00edsica",
  "Empregado Dom\\u00e9stico",
  "Enfermagem",
  "En\\u00f3logo",
  "Engenharia de Seguran\\u00e7a",
  "Estat\\u00edstico",
  "Fisioterapeuta e Terapeuta Ocupacional",
  "Farmac\\u00eautico",
  "Fonoaudi\\u00f3logo",
  "Garimpeiro",
  "Ge\\u00f3grafo",
  "Ge\\u00f3logo",
  "Guardador e Lavador de Ve\\u00edculos",
  "Instrutor de Tr\\u00e2nsito",
  "Jornalista",
  "Leiloeiro",
  "Leiloeiro Rural",
  "M\\u00e3e Social",
  "Massagista",
  "M\\u00e9dico",
  "Medicina Veterin\\u00e1ria",
  "Mototaxista e Motoboy",
  "Muse\\u00f3logo",
  "M\\u00fasico",
  "Nutricionista",
  "Ocean\\u00f3grafo",
  "Odontologia",
  "Orientador Educacional",
  "Pe\\u00e7\\u00e3o de Rodeio",
  "Pescador Profissional",
  "Psicologia",
  "Publicit\\u00e1rio/Agenciador de Propaganda",
  "Qu\\u00edmico",
  "Radialista",
  "Rela\\u00e7\\u00f5es P\\u00fablicas",
  "Representantes Comerciais Aut\\u00f4nomos",
  "Repentista",
  "Secret\\u00e1rio - Secret\\u00e1rio Executivo e T\\u00e9cnico em Secretariado",
  "Soci\\u00f3logo",
  "Sommelier",
  "Taxista",
  "Tradutor e Int\\u00e9rprete da L\\u00edngua Brasileira de Sinais - LIBRAS",
  "T\\u00e9cnico em Administra\\u00e7\\u00e3o",
  "T\\u00e9cnico Industrial",
  "T\\u00e9cnico em Pr\\u00f3tese Dent\\u00e1ria",
  "T\\u00e9cnico em Radiologia",
  "Turism\\u00f3logo",
  "Zootecnista",
];
function unicodeToChar(text) {
  return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
    return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
  });
}
const profs = rawprofs.map((e) => unicodeToChar(e));

export default profs;
